import type { JSX } from "react";
import type { SvgIconProps } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { css, styled } from "@mui/material";
import classNames from "classnames";


const ExpandIconRoot = styled(ExpandMore)(({ theme }) => css`
	pointer-events: none;
	transition: transform ${theme.transitions.duration.standard}ms;

	&.expanded {
		transform: scale(1, -1);
	}
`);

export type ExpandIconProps = SvgIconProps & {
	expanded?: boolean;
};
export const ExpandIcon = ({ className, expanded, ...svgIconProps }: ExpandIconProps): JSX.Element => (
	<ExpandIconRoot
		className={ classNames(className, { expanded }) }
		aria-hidden
		fontSize="large"
		{ ...svgIconProps }
	/>
);